<template>
  <div class="dashboard dashboard--active">
    <div class="dashboard__inner">
      <Menu></Menu>
      <div class="dashboard__main">
        <Header></Header>
        <div class="dashboard__content">
          <h3 class="dashboard__title">{{ pageName }}</h3>
          <!-- <breadcrumbs></breadcrumbs> -->
          <b-breadcrumb :items="items" class="breadcrumbs"/>
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/sass/admin-style.sass'

import Menu from './menu'
import Header from './header'
import Breadcrumbs from './plugins/breadcrumbs'

export default {
  name: 'advertiser',
  components: {
    Menu,
    Header,
    Breadcrumbs
  },
  data () {
    return {
      paths: {
        advertiser: 'Adop',
        'campaigns-manager': 'Campaigns Manager',
        domains: 'Domain lists',
        reports: 'Reports manager',
        bydate: 'by Date'
      },
      items: []
    }
  },
  computed: {
    pageName: function () {
      return this.$route.name
    }
  },
  methods: {
    updBreadcrumbs (upath) {
      upath.split('/').forEach(element => {
        if (element.length) {
          this.items.push({text: this.paths[element], class: 'breadcrumbs__item'})
        }
      })
    }
  },
  mounted: function () {
    // this.updBreadcrumbs(this.$route.fullPath)
  },
  updated () {
    console.log('updated ' + this.$route.fullPath)
    // var upath = this.$route.fullPath
    // upath.split('/').forEach(element => {
    //   if (element.length) {
    //     this.items.push({text: this.paths[element], class: 'breadcrumbs__item'})
    //   }
    // })
  }
}
</script>

<style>
/* BREADCRUMBS */
.breadcrumb-item + .breadcrumb-item::before {
  content: '';
}
.breadcrumb {
  background: none;
  border: none;
  list-style-type: none;
  padding: 0px;
  margin: 0px;
}
.breadcrumb-item a, .breadcrumb-item span{
    color: #A5ABB6;
    font-size: 1.6rem;
    letter-spacing: .01rem;
    padding: 0 2.2rem 0 2rem;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
}
.breadcrumb-item a{
  background: transparent url(/static/img/admin/breadcrumbs-arr.svg) right center no-repeat;
}
.breadcrumb-item:first-child a{
  padding-left: 0;
}
/* END */
ul.table__pagination{
  list-style-type: none;
}
ul.table__pagination li.page-item{
      width: 3rem;
    height: 3rem;
    font-size: 1.6rem;
    line-height: 3rem;
    text-align: center;
    margin-right: .5rem;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
}
ul.table__pagination li.page-item span{
    display: block;
    background-color: #FAFAFC;
    border: solid .1rem #E6E9F1;
    border-radius: .4rem;
    color: #535B6E;
}
ul.table__pagination li.page-item span:hover{
    cursor: pointer;
    background-color: #E6E9F1;
}

ul.table__pagination li.page-item:first-of-type span.page-link::before{
  font-family: FontAwesome; font-weight: 900; content: "\f100";
}
ul.table__pagination li.page-item:nth-of-type(2) span.page-link::before{
  font-family: FontAwesome; font-weight: 900; content: "\f104";
}
ul.table__pagination li.page-item:nth-last-of-type(2) span.page-link::before{
  font-family: FontAwesome; font-weight: 900; content: "\f105";
}
ul.table__pagination li.page-item:last-of-type span.page-link::before{
  font-family: FontAwesome; font-weight: 900; content: "\f101";
}
ul.table__pagination li.page-item a{
    color: #535B6E;
    font-size: 1.4rem;
}
ul.table__pagination li.page-item:first:before{
  font-family: FontAwesome;
   display: inline-block;
   content: "\f100";
}
.table__active-pages-input{
  width: 4rem;
}
input.table__active-pages-input {
    -moz-appearance:textfield;
}
input.table__active-pages-input::-webkit-outer-spin-button,
input.table__active-pages-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>



// WEBPACK FOOTER //
// src/components/advertiser/index.vue